import { Vue, sessionManager } from 'vue-infra';
import merge from 'lodash.merge';
import routes from './router/routes';
import { appCode, appName, PRIVILEGES } from '../config';
import { loadI18nResources } from './i18n/resource-resolver';
import { UPDATE_DISABLE_TYPING_EFFECT } from './store/types/action-types';
import resources from '../config/resources';

const AppComponent = r => require.ensure([], () => r(require('./App.vue')), 'AppComponent');
const appStore = r => require.ensure([], () => r(require('./store')), 'appStore');

// fixme - add instructions for every prop
const config = {

  id: appName,

  keepDOMRendered: false, // true -> use v-show instead of v-if in the application renderer

  moduleName: appName,

  routePrefix: appCode,

  // todo - don't just pass any persona
  personaMapping: appName,

  // todo - try passing ['*']
  personas: ['agent', 'messagingAgent', 'marketer', 'guest', 'admin', 'agentManager', appName],

  switcher: {

    // fixme (LE) - provide fallback in case this is not set
    control: `switcher-item-${appCode}`,

    fontIconName: 'ico-configuration', // icon for the navigation menu.

    // fixme (LE) - provide fallback in case this is not set
    index: 999999,
    // todo - try these
    titleTranslationKey: 'general.title',
    tooltipTranslationKey: 'general.title',
    // iconClass: 'ico-16 ico-switcher-item-automation-platform',
  },

  // @deprecated - will be removed in LE 10.9
  external: true,
  // @deprecated - will be removed in LE 10.9
  regionId: `${appName}-external`,
  // @deprecated - will be removed in LE 10.9
  container: 'work-area-wrapper',
  // @deprecated - will be removed in LE 10.9
  template: 'workAreaItemNoLEClass',
};

const canInitialize = (leAppConfig) => {
  if (leAppConfig.config) {
    merge(resources, leAppConfig.config);
  }
  const viewMCPrivilege = sessionManager.hasPrivilege(Number(PRIVILEGES.MC_VIEW_AND_ACCESS));
  const editMCPrivilege = sessionManager.hasPrivilege(Number(PRIVILEGES.MC_EDIT_AND_SAVE));
  const hasPrivilegeAccess = viewMCPrivilege || editMCPrivilege;
  // let hasFeatureAccess = true;
  // // We only want to disable by the feature if it exists, since it's true by default
  // if (sessionManager.getFeatureProperty('LEUI.ManagementConsole_Enabled')) {
  //   hasFeatureAccess = sessionManager.getFeaturePropertyState('LEUI.ManagementConsole_Enabled');
  // }
  let hasConfigAccess = true;
  if (leAppConfig && leAppConfig.config && leAppConfig.config.whitelist && leAppConfig.config.whitelist.indexOf) {
    hasConfigAccess = leAppConfig.config.whitelist.indexOf(sessionManager.getAccountId()) >= 0;
  }
  return hasPrivilegeAccess && hasConfigAccess;
};


const registerAppComponent = () => {
  // register the component globally to get the Vue.js dev-tools working.
  // the registration name must be the same as config.routePrefix, in order for the component to load property.
  Vue.component(appCode, {
    template: '<App/>',
    components: {
      App: AppComponent,
    },
  });
};

const applicationInit = async (leAppConfig) => {
  if (!canInitialize(leAppConfig)) {
    return {};
  }

  const i18nResources = await loadI18nResources(leAppConfig.locale, leAppConfig.fallbackLocale);

  appStore((store) => { // eslint-disable-line
    if (store && store.default && leAppConfig && leAppConfig.config) {
      store.default.dispatch(`${store.MODULES_PATHS.ROOT}/${UPDATE_DISABLE_TYPING_EFFECT}`, leAppConfig.config.disableTypingEffect || false);
    }
  });

  registerAppComponent();

  return {
    appId: appCode,
    routes,
    ...i18nResources,
  };
};

const webpackPathInit = (leAppConfig) => {
  __webpack_public_path__ = leAppConfig.publicPath; // eslint-disable-line
};


export default {
  config,
  // todo - rename to 'initialize'
  applicationInit,
  // todo - rename as lifecycle hook: 'on[Something]', i.e. according to the invoked LE lifecycle event.
  // todo - suggestions: onBootstrap, onAppsLoad
  webpackPathInit,
};
